import { z } from "zod";

/** Order help on the hosted chat, and the retailer's privacy notice. */
export const supportSchema = z
	.object({
		/** A "Help with an order" entry that asks the assistant (order status, then a person). */
		enabled: z.boolean().default(false),
		/** The retailer's privacy notice, linked from the hosted page (else /legal/privacy). */
		privacyUrl: z.url({ protocol: /^https$/ }).optional(),
	})
	.prefault({});
